<!-- 联系我们页面 -->
<template>
  <div class="address-container">
    <!-- Top Banner -->
    <img class="img-top" src="../../assets/img/联系我们.webp" alt="" />

    <!-- Contact Info + Map Section -->
    <div class="contact-section">
      <div class="contact-grid">
        <!-- Left: Contact Cards -->
        <div class="contact-cards">
          <div class="contact-card">
            <span class="contact-icon">🏢</span>
            <div class="contact-text">
              <span class="contact-label">{{ $i18n.locale === 'zh' ? '公司名称' : 'Company' }}</span>
              <span class="contact-value">{{ $t('address.companyName') }}</span>
            </div>
          </div>
          <div class="contact-card">
            <span class="contact-icon">👤</span>
            <div class="contact-text">
              <span class="contact-label">{{ $i18n.locale === 'zh' ? '联系人' : 'Contact' }}</span>
              <span class="contact-value">{{ $t('address.contact') }}</span>
            </div>
          </div>
          <div class="contact-card">
            <span class="contact-icon">📱</span>
            <div class="contact-text">
              <span class="contact-label">{{ $i18n.locale === 'zh' ? '手机' : 'Mobile' }}</span>
              <span class="contact-value">{{ $t('address.mobile') }}</span>
            </div>
          </div>
          <div class="contact-card">
            <span class="contact-icon">☎️</span>
            <div class="contact-text">
              <span class="contact-label">{{ $i18n.locale === 'zh' ? '座机' : 'Landline' }}</span>
              <span class="contact-value">{{ $t('address.landline') }}</span>
            </div>
          </div>
          <div class="contact-card">
            <span class="contact-icon">✉️</span>
            <div class="contact-text">
              <span class="contact-label">{{ $i18n.locale === 'zh' ? '邮箱' : 'Email' }}</span>
              <span class="contact-value">{{ $t('address.email') }}</span>
            </div>
          </div>
          <div class="contact-card">
            <span class="contact-icon">📍</span>
            <div class="contact-text">
              <span class="contact-label">{{ $i18n.locale === 'zh' ? '地址' : 'Address' }}</span>
              <span class="contact-value">{{ $t('address.bizAddress') }}</span>
            </div>
          </div>
        </div>

        <!-- Right: Map -->
        <div class="map-wrapper">
          <iframe
            :src="require('@/assets/map/index.html')"
            scrolling="no"
            frameborder="0"
          ></iframe>
        </div>
      </div>
    </div>

    <!-- QR Code Section -->
    <div class="qrcode-section">
      <div class="qrcode-card">
        <img src="../../assets/img/code.webp" alt="QR Code" />
        <p>{{ $t('address.qrcode') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  metaInfo() {
    return {
      title: this.$t('address.seoTitle'),
      meta: [
        {
          name: "description",
          content: this.$t('address.seoDescription'),
        },
        {
          name: "keywords",
          content: this.$t('address.seoKeywords'),
        },
      ],
    }
  },
  data() {
    return {};
  },
  mounted() {
    document.dispatchEvent(new Event("render-event"));
  },
};
</script>
<style lang="scss" scoped>
.address-container {
  width: 100%;
  min-width: auto;
  height: auto;
  background: #f8f9fc;

  @media (max-width: 768px) {
    margin-top: 30px;
  }

  .img-top {
    width: 100%;
    height: auto;
    display: block;
  }

  // ========== Contact + Map Section ==========
  .contact-section {
    max-width: 1150px;
    width: 100%;
    padding: 60px 20px 0;
    margin: 0 auto;

    @media (max-width: 768px) {
      padding: 32px 16px 0;
    }
  }

  .contact-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 30px;

    @media (max-width: 900px) {
      grid-template-columns: 1fr;
      gap: 24px;
    }
  }

  // ========== Contact Cards ==========
  .contact-cards {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .contact-card {
    display: flex;
    align-items: flex-start;
    gap: 14px;
    background: #fff;
    padding: 18px 20px;
    border-radius: 12px;
    box-shadow: 0 1px 8px rgba(0, 0, 0, 0.04);
    transition: transform 0.2s, box-shadow 0.2s;

    &:hover {
      transform: translateX(4px);
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
    }

    @media (max-width: 768px) {
      padding: 14px 16px;
      gap: 12px;
    }
  }

  .contact-icon {
    font-size: 24px;
    flex-shrink: 0;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f5f5f5;
    border-radius: 10px;

    @media (max-width: 768px) {
      font-size: 20px;
      width: 36px;
      height: 36px;
    }
  }

  .contact-text {
    display: flex;
    flex-direction: row;
    align-items: baseline;
    gap: 8px;
    min-width: 0;

    @media (max-width: 500px) {
      flex-direction: column;
      gap: 2px;
    }
  }

  .contact-label {
    font-size: 13px;
    color: #999;
    flex-shrink: 0;
    min-width: 60px;

    .lang-en & {
      font-size: 11px;
      min-width: 70px;
    }

    @media (max-width: 500px) {
      min-width: auto;
    }
  }

  .contact-value {
    font-size: 15px;
    color: #1a1a1a;
    line-height: 1.5;
    word-break: break-word;

    .lang-en & {
      font-size: 13px;
    }

    @media (max-width: 768px) {
      font-size: 14px;
      .lang-en & {
        font-size: 12px;
      }
    }
  }

  // ========== Map ==========
  .map-wrapper {
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
    min-height: 400px;

    @media (max-width: 900px) {
      min-height: 300px;
    }

    iframe {
      width: 100%;
      height: 100%;
      min-height: 450px;
      border: none;
      display: block;

      @media (max-width: 900px) {
        min-height: 300px;
      }
    }
  }

  // ========== QR Code Section ==========
  .qrcode-section {
    padding: 50px 20px 80px;
    display: flex;
    justify-content: center;

    @media (max-width: 768px) {
      padding: 32px 16px 60px;
    }
  }

  .qrcode-card {
    text-align: center;
    background: #fff;
    padding: 30px 40px;
    border-radius: 16px;
    box-shadow: 0 2px 16px rgba(0, 0, 0, 0.06);

    @media (max-width: 768px) {
      padding: 24px 30px;
    }

    img {
      width: 180px;
      height: 180px;
      display: block;
      margin: 0 auto 16px;
      border-radius: 8px;

      @media (max-width: 768px) {
        width: 140px;
        height: 140px;
      }
    }

    p {
      font-size: 14px;
      color: #666;
      margin: 0;

      @media (max-width: 768px) {
        font-size: 12px;
      }
    }
  }
}
</style>
